module.exports = __webpack_public_path__ + "static/STINGS_logoW-75b18a84ea508b19a9b3309e93fa99b9.svg";